export default __webpack_public_path__ + "static/media/copy-icon.086677c0.svg";